import { Box, Modal } from 'app/components/design-system-components'
import { Text } from 'app/components/design-system-components/typography'
import { history } from 'app/history'
import { urlIds, urlTo } from 'app/sm/helpers'

type ReferrerIdNotSetModalProps = {
  toggleModal: () => void
  teamSlug: string
  allowSkip?: boolean
  onSkip?: () => void
  sendUtilityReferralToLead?: () => void
  sendUtilityReferralToLeadAfterEditingID?: boolean
}

function ReferrerIdNotSetModal({
  toggleModal,
  teamSlug,
  allowSkip = false,
  sendUtilityReferralToLead,
  sendUtilityReferralToLeadAfterEditingID = true,
  onSkip,
}: ReferrerIdNotSetModalProps) {
  const handleNavigateToTeamMembers = () => {
    const url = urlTo(urlIds.teams.settings.members, { teamSlug })
    history.push(`${url}`)
    window.location.reload()
  }

  // Handle skip action
  const handleSkip = () => {
    if (sendUtilityReferralToLeadAfterEditingID) {
      sendUtilityReferralToLead && sendUtilityReferralToLead()
    }
    if (onSkip) {
      onSkip()
    }
    toggleModal()
  }

  const secondaryLabel = allowSkip ? 'Send Anyway' : 'Close'
  const secondaryAction = allowSkip ? handleSkip : toggleModal

  const modalBody = (
    <Box>
      <Text mb={3}>
        You don’t have a Utility Connection Service (UCS) Referrer ID set. Your
        team admin should set it in{' '}
        <Text
          as="span"
          color="blue"
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
          onClick={() => handleNavigateToTeamMembers()}
        >
          Team Members
        </Text>{' '}
        before you send a referral.
      </Text>
    </Box>
  )

  return (
    <Modal
      modalHeading="UCS Referrer ID is not set"
      modalBody={modalBody}
      toggleModal={toggleModal}
      showPrimaryButton={true}
      primaryLabel="Close"
      primaryAction={toggleModal}
      showSecondaryButton={true}
      modalFooter={undefined}
      secondaryLabel={secondaryLabel}
      secondaryAction={secondaryAction}
    />
  )
}

export default ReferrerIdNotSetModal
